import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/planit_studio/";
const WHATSAPP_URL = "https://wa.me/390743050842";

const WhatsAppIcon = ({ size = 18 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.53 0 .23 5.3.23 11.83c0 2.08.55 4.11 1.6 5.9L0 24l6.42-1.69a11.83 11.83 0 0 0 5.64 1.44h.01c6.53 0 11.83-5.3 11.83-11.83 0-3.16-1.23-6.13-3.38-8.44Zm-8.46 18.2h-.01a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.81 1 1.02-3.71-.23-.38a9.82 9.82 0 0 1-1.5-5.18c0-5.43 4.42-9.85 9.85-9.85 2.63 0 5.1 1.03 6.96 2.89a9.79 9.79 0 0 1 2.88 6.96c0 5.43-4.42 9.85-9.79 9.85Zm5.4-7.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.24-.46-2.37-1.46-.87-.78-1.46-1.73-1.63-2.03-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.19-.24-.58-.48-.5-.66-.51h-.56c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.46s1.05 2.85 1.2 3.05c.15.2 2.08 3.17 5.03 4.44.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.11.56-.08 1.75-.71 2-1.4.24-.68.24-1.27.17-1.4-.07-.13-.27-.2-.57-.35Z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-stone-200 bg-[#F9F8F6] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        {/* Left: logo + name (smaller, STUDIO on new line) */}
        <div className="flex items-center gap-3 justify-center md:justify-start" data-testid="footer-brand">
          <img
            src="/logo.png"
            alt="Plan It Studio"
            className="h-11 w-auto object-contain"
          />
          <span className="font-neris leading-tight">
            <span className="block text-planit-gradient text-lg" style={{ letterSpacing: "0.08em" }}>PLAN IT</span>
            <span className="block text-stone-900 text-sm tracking-widest">STUDIO</span>
          </span>
        </div>

        {/* Center: legal info */}
        <div className="text-center text-xs text-stone-500 leading-relaxed" data-testid="footer-legal">
          <p>Plan It Studio s.r.l. s.t.p. — p.iva 03978190548</p>
          <p>Via Giuseppe Saragat 12a, 06049 Spoleto (PG)</p>
          <p className="mt-2 uppercase tracking-widest">
            © 2026 Plan It Studio. Tutti i diritti riservati.
          </p>
        </div>

        {/* Right: quick links + socials */}
        <div className="flex flex-col items-center md:items-end gap-4" data-testid="footer-right">
          <nav className="flex flex-wrap gap-x-5 gap-y-2 justify-center md:justify-end text-xs text-stone-600">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-[#D06D4D] transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie" className="hover:text-[#D06D4D] transition-colors">Cookie Policy</Link>
            <Link to="/note-legali" data-testid="footer-legal-note" className="hover:text-[#D06D4D] transition-colors">Note Legali</Link>
          </nav>
          <div className="flex items-center gap-4">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="text-stone-600 hover:text-[#D06D4D] transition-colors"
            >
              <Instagram size={18} />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
              className="text-stone-600 hover:text-[#25D366] transition-colors"
            >
              <WhatsAppIcon size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
